/**
 * Minimal Theme Configuration
 *
 * Clean, minimal styling with subtle backgrounds.
 * Best for: Internal tools, admin panels, documentation sites
 */

import type { ThemeConfig } from '#src/errors/types';

export const minimalTheme: ThemeConfig = {
  iconSize: 'h-10 w-10',
  badgeStyle: 'rounded-full border border-border/40 bg-muted/50 px-4 py-1.5',
  headingSize: 'text-3xl sm:text-4xl',
  animation: false
} as const;
